module.exports = __webpack_public_path__ + "public/img/up.3dc0c38c.svg";